import * as React from 'react'
import BlockContent from '@sanity/block-content-to-react'
import { useLocale } from '../../providers/LocaleProvider'
import { LocaleRichText } from '../../types'
import { RichTextWrapper } from './styles'

interface RichTextProps {
  richText?: LocaleRichText
}

const serializers = {
  types: {
    block: (props: any) => <p>{props.children}</p>,
  },
}

export const RichText: React.FC<RichTextProps> = ({ richText }) => {
  const { getTranslation } = useLocale()
  if (!richText) return null
  const body = getTranslation(richText)
  if (!Array.isArray(body)) return null
  return (
    <RichTextWrapper>
      <BlockContent blocks={body} serializers={serializers} />
    </RichTextWrapper>
  )
}
